module.exports = __webpack_public_path__ + "static/media/R-300HD_CrossSection.6f0dcd60.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/chambers/es/R-300HD_CrossSection.png
// module id = 486
// module chunks = 0